import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { Skeleton } from '@atlassian/mpac-ui';
import React from 'react';
import { PricingDescription } from "../PricingTab.styles";
export var PricingTierRowSkeleton = /*#__PURE__*/_styled(Skeleton.Row, {
  target: "ecdc76y0",
  label: "PricingTierRowSkeleton"
})(process.env.NODE_ENV === "production" ? {
  name: "1tyndxa",
  styles: "justify-content:center;"
} : {
  name: "1tyndxa",
  styles: "justify-content:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcExpc3RpbmcvdGFicy9QcmljaW5nVGFiL1ByaWNpbmdUaWVycy9QcmljaW5nVGllcnNTa2VsZXRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRMEQiLCJmaWxlIjoiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQXBwTGlzdGluZy90YWJzL1ByaWNpbmdUYWIvUHJpY2luZ1RpZXJzL1ByaWNpbmdUaWVyc1NrZWxldG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcblxuaW1wb3J0IHsgU2tlbGV0b24gfSBmcm9tICdAYXRsYXNzaWFuL21wYWMtdWknO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgUHJpY2luZ0Rlc2NyaXB0aW9uIH0gZnJvbSAnLi4vUHJpY2luZ1RhYi5zdHlsZXMnO1xuXG5leHBvcnQgY29uc3QgUHJpY2luZ1RpZXJSb3dTa2VsZXRvbiA9IHN0eWxlZChTa2VsZXRvbi5Sb3cpYFxuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbmA7XG5cbi8qKlxuICogUmVuZGVycyB0aGUgbG9hZGluZyBzdGF0ZSBvZiB0aGUgcHJpY2luZyB0YWIgdGllcnMgYXMgYSBcInNrZWxldG9uXCIgb3IgXCJzaGltbWVyXCJcbiAqL1xuY29uc3QgUHJpY2luZ1RpZXJzU2tlbGV0b24gPSAoKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIDxQcmljaW5nRGVzY3JpcHRpb24+XG4gICAgICAgIDxTa2VsZXRvbi5CbG9jayB3aWR0aD17NDAwfSBoZWlnaHQ9ezIwfSAvPlxuICAgICAgPC9QcmljaW5nRGVzY3JpcHRpb24+XG4gICAgICA8UHJpY2luZ1RpZXJSb3dTa2VsZXRvbj5cbiAgICAgICAgPFNrZWxldG9uLkJsb2NrIHdpZHRoPXsxNTB9IGhlaWdodD17MTUwfSBtYXJnaW5SaWdodD17MTB9IC8+XG4gICAgICAgIDxTa2VsZXRvbi5CbG9jayB3aWR0aD17MTUwfSBoZWlnaHQ9ezE1MH0gbWFyZ2luUmlnaHQ9ezEwfSAvPlxuICAgICAgICA8U2tlbGV0b24uQmxvY2sgd2lkdGg9ezE1MH0gaGVpZ2h0PXsxNTB9IG1hcmdpblJpZ2h0PXsxMH0gLz5cbiAgICAgICAgPFNrZWxldG9uLkJsb2NrIHdpZHRoPXsxNTB9IGhlaWdodD17MTUwfSBtYXJnaW5SaWdodD17MTB9IC8+XG4gICAgICAgIDxTa2VsZXRvbi5CbG9jayB3aWR0aD17MTUwfSBoZWlnaHQ9ezE1MH0gbWFyZ2luUmlnaHQ9ezEwfSAvPlxuICAgICAgPC9QcmljaW5nVGllclJvd1NrZWxldG9uPlxuICAgICAgPFByaWNpbmdUaWVyUm93U2tlbGV0b24+XG4gICAgICAgIDxTa2VsZXRvbi5CbG9jayB3aWR0aD1cIjcwJVwiIGhlaWdodD17NTB9IG1hcmdpblRvcD17MzB9IC8+XG4gICAgICA8L1ByaWNpbmdUaWVyUm93U2tlbGV0b24+XG4gICAgPC8+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBQcmljaW5nVGllcnNTa2VsZXRvbjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
/**
 * Renders the loading state of the pricing tab tiers as a "skeleton" or "shimmer"
 */

var PricingTiersSkeleton = function PricingTiersSkeleton() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PricingDescription, null, /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: 400,
    height: 20
  })), /*#__PURE__*/React.createElement(PricingTierRowSkeleton, null, /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: 150,
    height: 150,
    marginRight: 10
  }), /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: 150,
    height: 150,
    marginRight: 10
  }), /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: 150,
    height: 150,
    marginRight: 10
  }), /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: 150,
    height: 150,
    marginRight: 10
  }), /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: 150,
    height: 150,
    marginRight: 10
  })), /*#__PURE__*/React.createElement(PricingTierRowSkeleton, null, /*#__PURE__*/React.createElement(Skeleton.Block, {
    width: "70%",
    height: 50,
    marginTop: 30
  })));
};

export default PricingTiersSkeleton;